import React from 'react'
import Image from 'next/image'
import classnames from 'classnames/bind'

import PropTypes from 'prop-types'

import { avatarLetters } from 'Utils/user'

import styles from './Avatar.module.css'
import { cloudinaryAvatarUrlCropped } from 'Utils/cloudinary'
const cx = classnames.bind(styles)

const Avatar = ({ small = false, image, alt }) => {
  const letters_classes = cx({
    ['avatar-letters']: true,
    small: small,
  })

  if (!image) {
    return <div className={letters_classes}>{avatarLetters(alt)}</div>
  }

  let width = small ? 56 : 250
  let height = small ? 56 : 250

  const classes = cx({
    avatar: true,
    small: small,
  })

  return (
    <div className={classes}>
      <Image
        className={styles['image']}
        src={cloudinaryAvatarUrlCropped(image) || '/avatar.png'}
        alt={alt}
        objectFit="cover"
        objectPosition="center"
        priority={true}
        quality="90"
        width={width}
        height={height}
        sizes={`${width}px`}
      />
    </div>
  )
}

Avatar.propTypes = {
  image: PropTypes.string,
  alt: PropTypes.string.isRequired,
}

export default React.memo(Avatar)
